/** バックエンド `STALE_RUNNING_CANCEL_REFUND_AFTER_MS` と同じ。開始からこの時間以上で返金キャンセルできる。 */
export const STALE_AI_PROOFREADING_REFUND_AFTER_MS = 30 * 60 * 1000;

export function isStaleAiProofreadingRefund(
  createdAt: number | null | undefined,
  nowMs: number,
): boolean {
  if (typeof createdAt !== "number" || !Number.isFinite(createdAt)) return false;
  if (!Number.isFinite(nowMs)) return false;
  return nowMs - createdAt >= STALE_AI_PROOFREADING_REFUND_AFTER_MS;
}
